/** Mirrors the backend CollectionMethodContract (serialized as PascalCase strings), PD-0043. */
export enum CollectionMethod {
  SepaDebit = "SepaDebit",
  Card = "Card",
}
